import {
  createContext,
  type ReactElement,
  type ReactNode,
  useContext,
  useReducer,
  type Dispatch
} from 'react'
import type MenuContextProps from './MenuContext.types'

interface Action {
  readonly type: 'setMenuProps'
  readonly payload: MenuContextProps
}

interface State {
  readonly menuContext: MenuContextProps
}

interface MenuContextProviderProps {
  readonly children: ReactNode
}

const initialState: State = {
  menuContext: {
    menuOpen: false,
    menuExtended: true,
  },
}

const MenuStateContext = createContext<[State, Dispatch<Action>]>([
  initialState,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  (action): void => {},
])

function menuReducer(state: State, action: Action): State {
  if (action.type === 'setMenuProps') {
    return { menuContext: action.payload }
  } else {
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    throw new Error(`Unhandled action type: ${action.type}`)
  }
}

function MenuContextProvider({
  children,
}: MenuContextProviderProps): ReactElement {
  const store = useReducer(menuReducer, initialState)
  return (
    <MenuStateContext.Provider value={store}>
      {children}
    </MenuStateContext.Provider>
  )
}

function useMenuContext() {
  const context = useContext(MenuStateContext)
  if (context === undefined) {
    throw new Error('error')
  }
  return context
}

export { MenuContextProvider, useMenuContext }
